var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowSpinner)?_c('v-progress-linear',{attrs:{"size":_vm.size || 25,"indeterminate":"","color":"primary"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }